import { render } from "./CobaltDashboard.vue?vue&type=template&id=01a21e0e"
import script from "./CobaltDashboard.vue?vue&type=script&lang=js"
export * from "./CobaltDashboard.vue?vue&type=script&lang=js"

import "./CobaltDashboard.vue?vue&type=style&index=0&id=01a21e0e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__